export interface ValidatePushDateReturn {
	isValid: boolean
	message: string
}

export const validatePushDate = (
	pushDate: string,
	contentDate: string,
	expirationDate: string
): ValidatePushDateReturn => {
	const push = pushDate ? new Date(pushDate) : new Date(Date.now())
	const content = new Date(contentDate)
	const expiration = new Date(expirationDate)

	if (push < content) {
		return {
			isValid: false,
			message:
				'The notification date cannot be earlier than the content publish date.'
		}
	}

	if (push > expiration) {
		return {
			isValid: false,
			message:
				'The notification date cannot be later than the content expiration date.'
		}
	}

	return {
		isValid: true,
		message: 'The notification date is valid.'
	}
}
